package com.cs.ejobin.data.supabase.dto
    
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ProfileRow(
    val id: String,
    val name: String,
    val phone: String,
    @SerialName("is_available") val isAvailable: Boolean,
    @SerialName("photo_url") val photoUrl: String? = null,
    val skills: List<String> = emptyList(),
    val description: String? = ""
)